import { render, staticRenderFns } from "./Packing.vue?vue&type=template&id=c377f14a&scoped=true&"
import script from "./Packing.vue?vue&type=script&lang=js&"
export * from "./Packing.vue?vue&type=script&lang=js&"
import style0 from "./Packing.vue?vue&type=style&index=0&id=c377f14a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c377f14a",
  null
  
)

export default component.exports